var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFolderOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "7 7 30 30",
    fill: "none",
    stroke: "#929497",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 20.25v-3.5h-8.25V15H13v14m0 0h15l3-8.75H16L13 29z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgFolderOpen;